import { css } from "styled-components";

import { aStyles as defaultAStyles } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html/a/styles";
import { getBaseFont } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const aStyles = css`
  ${defaultAStyles}
  ${getBaseFont("brandon-regular")}
`;
